import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  title: {
    textAlign: 'center',
    marginBottom: '6px',
  },
  subtitle: {
    color: '#AAA',
    textAlign: 'center',
    marginBottom: '12px',
  },
})

export function TitleLogin() {
  const { t } = useTranslation()
  return (
    <>
      <Text variant="h4" rootStyle={styles.title}>{t('login.pleaseEnterPhone')}</Text>
      <Text variant="body" rootStyle={styles.subtitle}>{t('login.unregisteredPhoneContent')}</Text>
    </>
  )
}
